import { MediaWrapper } from '@/components/Cms/MediaWrapper';
import type { ContentfulImageWithFocalPointFragment } from '@/graphql/contentful/api';
import { cleanObject } from '@/lib/util';

import type { CardProps } from '../../types';
import { TextType } from '../TextType';

import * as S from './MediaAndSideTextType.styles';

export const MediaAndSideTextType = (_props: CardProps) => {
  const props: CardProps = {
    contentAlignment: 'center',
    textAlignment: 'center',
    type: 'default',
    urlType: 'button',
    ...cleanObject(_props),
  };
  const processedProps = {
    ...props,
  };
  const textAlign = props.textAlignment || 'center';
  const backgroundPosition = props?.backgroundPosition || '50%';
  const backgroundAlignment = props?.backgroundAlignment ?? 'right';
  const hasMedia = !!(props.media?.image?.url || props.media?.video?.url);

  return (
    <S.Wrapper
      $visibleInDesktop={_props.visibleInDesktop}
      $visibleInMobile={_props.visibleInMobile}
      backgroundColor={hasMedia ? 'transparent' : props?.backgroundColor?.value}
      className={_props.className}
      data-test-id='MediaAndSideTextTypeWrapper'
      imagePosition={backgroundAlignment}
    >
      {props.media?.image?.url && (
        <S.ImageWrapper
          backgroundPosition={backgroundPosition as string}
          data-test-id='MediaAndSideTextTypeImageWrapper'
          mediaAnimationEffect={
            props?.mediaAnimationEffect === 'zoomOnHover'
              ? props?.mediaAnimationEffect
              : null
          }
        >
          <S.Media $backgroundAlignment={props.backgroundAlignment}>
            <MediaWrapper
              {...(props.media as ContentfulImageWithFocalPointFragment)}
              aspectRatio={props.aspectRatio}
              data-test-id='BaseCardTypeBackgroundImage'
              mediaWrapperType={props.mediaWrapperType}
              preload={props.preload}
              sizes='(max-width: 600px) 50vw, 50vw'
            />
          </S.Media>
        </S.ImageWrapper>
      )}
      <S.Content
        backgroundColor={props?.backgroundColor?.value}
        backgroundPosition={backgroundPosition as string}
        data-test-id='MediaAndSideTextTypeContent'
        textAlignment={textAlign}
      >
        <TextType {...processedProps} />
      </S.Content>
    </S.Wrapper>
  );
};

MediaAndSideTextType.displayName = 'MediaAndSideTextType';
